export default __webpack_public_path__ + "static/media/FACIALsmall.2f3eba8b.png";